export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'home'}
        },

        {
            icon: 'mdi-clipboard-text-multiple-outline',
            name: 'الامتحانات',
            text: 'الامتحانات',
            to: {name: 'exams'},
        },
        {
            icon: 'mdi-file-plus-outline',
            name: 'سؤال جديد',
            to: {name: 'new-question'},
        },
        {
            icon: 'mdi-file-question-outline',
            name: 'بنك الأسئلة',
            to: {name: 'questions'},
        },
        {
            icon: 'mdi-order-bool-descending-variant',
            name: 'عمليات شراء المحاضرات',
            to: {name: 'lectures-purchases'},
            if: 'showLecturesPurchases'
        },
        {
            icon: 'mdi-order-bool-descending-variant',
            name: 'عمليات شراء الدورات',
            to: {name: 'courses-purchases'},
            if: 'showCoursesPurchases'
        },
        {
            icon: 'mdi-file-export-outline',
            name: 'الملفات المستخرجة',
            to: {name: 'export-files'},
        },
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            disabled: true,
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'حساب جديد',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'تسجيل الدخول',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-information-outline',
            name: 'عن المنصة',
            to: {name: 'about'}
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: {name: 'privacy-policy'}
        },
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            disabled: true,
            to: {name: 'help'}
        }
    ]
}